import Echo from "laravel-echo";
import * as Sentry from "@sentry/browser"
import {Vue as VueIntegration} from "@sentry/integrations"
import Cookies from 'js-cookie'

window.debugMode = process.env.MIX_APP_DEBUG === "true"
window.productionMode = process.env.MIX_APP_DEBUG !== "true"
window.echoEnabled = process.env.MIX_ECHO_ENABLED === "true"

// Globals

window._ = require("lodash");
window.axios = require("axios");
window.Vue = require("vue");
window.Popper = require("popper.js").default;
window.$ = window.jQuery = require("jquery");
window.Swal = require('sweetalert2');
window.Pusher = require("pusher-js");
window.feather = require('./js/feather.min')
window.tns = require('tiny-slider/src/tiny-slider').tns
window.Cookies = Cookies
window.io = require('socket.io-client');


// Requires

require("owl.carousel");
require("bootstrap");
require('./js/headroom')
require("./js/jquery.meanmenu.min");
require("./js/wow.min");
require("./js/jquery.magnific-popup.min");
require("./js/slick");
require("./js/jquery.appear");
require("./js/odometer.min");

// Axios

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// Echo

Pusher.logToConsole = true;

if (echoEnabled && typeof io !== 'undefined') {
    window.Echo = new Echo({
        broadcaster: "socket.io",
        host: window.location.hostname + ':6001',
        transports: ['websocket', 'polling', 'flashsocket'], // Fix CORS error!
        auth: {
            headers: {
                Authorization: 'Bearer '+ window.jwt_token,
            }
        }
    });
}

// Sentry

if (process.env.MIX_SENTRY_ENABLED === "true") {
    console.log('initializing sentry.. dsn:' + process.env.MIX_SENTRY_VUE_DSN)
    Sentry.init({
        dsn: process.env.MIX_SENTRY_VUE_DSN,
        integrations: [new VueIntegration({
            Vue,
            attachProps: true,
            logErrors: true,
        })],
        // autoSessionTracking: true,
        // Todo Enable For Performance Monitor
        // integrations: [new Integrations.BrowserTracing()],
        // tracesSampleRate: 0,
    });
}
